// import headerBg from '@/assets/images/active/travel/hlw/part/header_bg.png';
import headerBg2 from '@/assets/images/active/travel/header/header_bg2.png';
import loginBtn from '@/assets/images/active/travel/header/btn_06.png';
import accountBtn from '@/assets/images/active/travel/header/btn_07.png';
import activeBtn from '@/assets/images/active/travel/header/btn_09.png';
import logoutBtn from '@/assets/images/active/travel/header/btn_10.png';
// import loadBtn from '@/assets/images/active/travel/hlw/part/load.png';

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg2,
    style: ''
  },
  logged_in: {
    background_image: 'https://download4.qcplay.com/h5-images/active/travel/hlw/part/header_bg.png',
    main_title_color: '#FFFFFF',
    sub_title_color: '#FFFFFF',
    tips_color: '#825339',
    game_name: '时光旅行社'
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: 'https://download4.qcplay.com/h5-images/active/travel/hlw/part/load.png',
      style: 'top: 0.35rem',
      link: 'https://download4.qcplay.com/apk-v2/qc-kol-1146043.apk'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: 'top: 0.35rem'
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: accountBtn,
      style: 'top: 0.35rem'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: activeBtn,
      style: 'top: 0.35rem',
      link: 'https://qcg.ink/XrLOO4'
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: 'top: 0.35rem'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/travel/hlw/headerConfig.js